import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { ResultCount } from '@uhg-abyss/web/ui/Pagination';
import React from 'react';

import { Styles } from './includes/styles';

type ResultsCountProps = {
  currentPage: number;
  resultsPerPage: number;
  totalResults: number;
};

/**
 * ResultsCount
 *
 * Displays the range of results currently displayed along with the total number of results.
 */
export function ResultsCount({ currentPage = 0, resultsPerPage = 25, totalResults = 0 }: ResultsCountProps) {
  return (
    <ErrorHandler location="src/shared/ui/components/TableQuery/components/ResultsCount/ResultsCount.tsx">
      <Styles>
        <ResultCount pageIndex={currentPage} pageSize={resultsPerPage} resultsTotalCount={totalResults} />
      </Styles>
    </ErrorHandler>
  );
}
